import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import './copyright.css'
import InternationalizedFormattedText from '../../../../util/internationalized-formatted-text'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  copyright: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.footer.main,
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(0.75),
    },
  },
}))

const Copyright = () => {
  const year = new Date().getFullYear()
  const classes = useStyles()
  const brand = useSelector((state) => state.reducer.brand)

  return (
    <div className={classes.copyright}>
      <Typography variant='body2'>{year}</Typography>
      <InternationalizedFormattedText variant='body2' id='rights' values={{ brand: brand.name }} />
    </div>
  )
}

export default Copyright
